import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import { MobileHeader } from '../../components/MobileHeader';
import styles from './DashboardLayout.module.css';

const DashboardLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      setCollapsed(mobile);
      // Close sidebar when resizing to desktop
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    // Set initial state
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleNavigation = () => {
    // Close sidebar when navigating on mobile
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className={styles.dashboardLayout}>
      {isMobile && (
        <MobileHeader onMenuToggle={handleMenuToggle} sidebarOpen={sidebarOpen} />
      )}
      <Sidebar collapsed={collapsed} open={sidebarOpen} />
      <main className={styles.mainContent} onClick={handleNavigation}>
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
